<template>
  <b-col md="6">
    <div class="alert overflow_div alert-info">

      <label>
        برند ها
        <b-icon icon="arrow-clockwise" class="d-inline" @click="refreshBrands"></b-icon>
      </label>
      <div class="selected_brand my-3">
        <b-button @click="removeBrand()" pill variant="primary" v-if="inputValue">{{ inputValue.name }}</b-button>
      </div>

      <b-form @submit.prevent="searchBrand()">
        <b-form-input
            id="input"
            v-model="searchedWord"
            placeholder=" جستجو"
            class="mb-1"
        ></b-form-input>
      </b-form>

      <form-group :validations="validation">
        <div slot-scope="{ errors, invalid }">

          <div v-for="item in brands">
            <input
                type="hidden"
                :value="`item_${item.id}`"
                :class="{ invalid }"
                name="item"
            />
            <label class="mr-1" @click="selectBrand(item)" :data-value="item.name" :data-name="item.id"
                   :for="`item_${item.id}`" :key="item.id">
              {{ item.name }}
            </label>
          </div>


          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>


    </div>
  </b-col>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from "../../validator/FormErrorsManager";

export default {
  name: "Brand",
  components: {FormGroup, FormErrorsManager},
  props: {
    brands: {
      default: []
    },
    validation: {},
    inputValue: {},
  },
  model: {
    prop: "inputValue",
    event: "input",
  },
  data() {
    return {
      searchedWord: '',
    }
  },
  methods: {
    refreshBrands() {
      this.$store.dispatch("Brand/getBrands");
    },
    selectBrand(item) {
      this.$emit("input", item);
    },
    searchBrand() {
      if (this.searchedWord != "") {
        const searchWord = {words: this.searchedWord};
        this.$store.dispatch("Brand/searchBrand", {form: searchWord, page: 1});
      }
    },
    removeBrand() {
      if (confirm('از حذف برند محصول اطمینان دارید؟')) {
        this.$emit("input", '');
      }
    }
  }
}
</script>

<style scoped>
.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>